import 'slick-carousel';
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery';

// Ensure slick library has been included
if ( typeof $.fn.slick == 'function' ) {

    const $js_slider = $( '.js-slider' );

    var slickConfig = {
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Previous" type="button"><i class="fal fa-angle-left fa-3x" aria-hidden="true"></i></button></i>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Next" type="button"><i class="fal fa-angle-right fa-3x" aria-hidden="true"></i></button>'
    };
    
    $js_slider.slick( slickConfig );
    
    
    // Flexible Testimonials & Flexible Post Tabs (Mobile Slider)
    slickConfig = Object.assign( slickConfig, {
        arrows: false,
        dots: true
    } );

    const $_slider = $( '.testimonials__slider, .post-tabs__slider, .post-previews__row--slider' );

    $_slider.slick( slickConfig );

}
